import { render, staticRenderFns } from "./confirm-start-examination-dialog.vue?vue&type=template&id=b5c11b82&scoped=true"
import script from "./confirm-start-examination-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./confirm-start-examination-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./confirm-start-examination-dialog.vue?vue&type=style&index=0&id=b5c11b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c11b82",
  null
  
)

export default component.exports